define('languages/lang',[
  'backbone',
  'jquery',
  '_',
  'polyglot',

  './sv_SE',
  './en_US',
  './fi_FI'],
  function(Backbone, $, _, Polyglot, sv_SE, en_US, fi_FI) {
    'use strict';
    var Lang = function(langCode) {

      // TODO: load lang via ajax instead?
      var polyglot = new Polyglot({phrases: fi_FI, locale: langCode});
      var t = polyglot.t;


       // make _.t to an alias for polyglot.t for better/easier use in templates
      _.mixin({ 't': function(key, opts) {
        return polyglot.t(key, opts);
      }});

    };

    Lang.prototype.phrases = fi_FI;

    return Lang;
  });

